import { yupResolver } from '@hookform/resolvers/yup'
import { Close } from '@mui/icons-material'
import {
  CardActions,
  CardContent,
  Divider,
  Grid,
  Typography
} from '@mui/material'
import {
  Button,
  Card,
  CardHeader,
  IconButton,
  Modal,
  TextFieldC
} from 'components'
import { FormProvider, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { Yup } from 'utils'
import { duplicateOrderStore } from './duplicateOrderStore'

const schema = Yup.object({
  opportunityId: Yup.string().required()
})

function DuplicateModal() {
  const isOpen = duplicateOrderStore.useIsModalOpen()
  const setIsOpenModal = duplicateOrderStore.useSetModalIsOpen()
  const proposalId = duplicateOrderStore.useProposalId()
  const navigation = useNavigate()

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      text: ''
    }
  })

  const { handleSubmit, reset } = methods

  const onClose = () => {
    setIsOpenModal(false)
  }

  const onSubmit = async () => {
    try {
      navigation(`${proposalId}/duplicate`)
      setIsOpenModal(false)
      reset()
    } catch {}
  }

  return (
    <FormProvider {...methods}>
      <Modal
        open={isOpen}
        onClose={onClose}
        keepMounted={false}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <Card style={{ padding: 0, minWidth: 300, width: 600 }}>
          <CardHeader
            title={`DUPLICAR ORÇAMENTO: ${proposalId || ''}`}
            HeaderRight={
              <IconButton onClick={() => onClose()}>
                <Close />
              </IconButton>
            }
          />
          <Divider />

          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography>Digite uma oportunidade para continuar</Typography>
              </Grid>
              <Grid item xs={12}>
                <TextFieldC name="opportunityId" label={`Oportunidade`} />
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardActions>
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                gap: '1rem'
              }}
            >
              <Button
                variant="text"
                sx={{
                  width: { sm: 100, md: 200 }
                }}
                onClick={() => onClose()}
              >
                Cancelar
              </Button>
              <Button
                sx={{
                  width: { sm: 100, md: 200 }
                }}
                type="button"
                onClick={handleSubmit(onSubmit)}
              >
                Duplicar
              </Button>
            </div>
          </CardActions>
        </Card>
      </Modal>
    </FormProvider>
  )
}
export default DuplicateModal
